import { SearchType } from '@lmt/unicorn-shared/app/components/search/types';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './SearchTypeTab.module.scss';

interface Props {
  title: SearchType;
  isSelected: boolean;
  onClick: (title: SearchType) => void;
}

export const SearchTypeTab: FC<Props> = (props) => {
  const { title, isSelected, onClick } = props;
  const i18n = useTranslation();
  return (
    <div
      className={styles.tab}
      data-selected={isSelected}
      onClick={() => !isSelected && onClick(title)}
    >
      <div className={styles.title}>
        {i18n.t(`extended_search.tabs.${title}`)}
      </div>
      <div data-selected={isSelected} className={styles.underline} />
    </div>
  );
};
